import { AuthHttp } from '@elotech/angular-common';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CanActivateAdminRoute  {
  constructor(public authHttp: AuthHttp) {}

  canActivate(): Observable<boolean> | boolean {
    return this.authHttp.isAdmin();
  }
}
